import React, { Fragment, useState } from 'react';
import moment from 'moment';
import { Draggable } from 'react-beautiful-dnd';
import { CategoryRow, CategoryDrag, OrangeBadge } from './styled';
import { isEmpty } from 'lodash';
import { LoadingWrapper } from '../../../../styles/styled';
import Loading from '../../../../components/Loading';
import styled from 'styled-components';

const getDraggableItemStyle = (isDragging, draggableStyle) => ({
  ...draggableStyle,
});

export default function CategoryDraggable(props) {
  const {
    index,
    category,
    byId,
    onDelete,
    onEdit,
    onTitleChange,
    onSetAsFeatured,
    onClearFeatured,
    isPlanNotPermitted,
  } = props;
  const [editCategoryTitle, setEditCategoryTitle] = useState(false);
  const [categoryTitle, setCategoryTitle] = useState(category.name);
  const [newCategoryTitle, setNewCategoryTitle] = useState(category.name);
  const soundcasts = !isEmpty(byId) ? byId : [];
  return (
    <Draggable
      key={`category-${category.id}`}
      draggableId={`category-${category.id}`}
      index={index}
      isDragDisabled={isPlanNotPermitted}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getDraggableItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
          <CategoryRow>
            <CategoryDrag>
              <i className="material-icons">drag_handle</i>
            </CategoryDrag>
            <div className={'categoryName position-relative'}>
              {editCategoryTitle ? (
                <Fragment>
                  <div className="categoryNameEditWrap">
                    <div className="categoryNameInput">
                      <input
                        className="form-control"
                        placeholder={'Enter Category name...'}
                        value={newCategoryTitle}
                        onChange={e => setNewCategoryTitle(e.target.value)}
                      />
                    </div>
                    <div className="categoryNameActions">
                      <button
                        className="btn btn-orange me-1"
                        onClick={() => {
                          setCategoryTitle(newCategoryTitle);
                          setEditCategoryTitle(false);
                          onTitleChange(newCategoryTitle);
                        }}>
                        Save
                      </button>
                      <button className="btn btn-blue" onClick={() => setEditCategoryTitle(false)}>
                        Cancel
                      </button>
                    </div>
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <span>{categoryTitle}</span>{' '}
                  {category.featured ? <OrangeBadge>featured</OrangeBadge> : null}{' '}
                  <ItemIcon
                    className="material-icons"
                    onClick={() => {
                      if (isPlanNotPermitted) {
                        props.onClickEdit(true);
                        return;
                      }
                      setNewCategoryTitle(categoryTitle);
                      setEditCategoryTitle(true);
                    }}>
                    edit
                  </ItemIcon>
                </Fragment>
              )}
            </div>
            <div className={'soundcastCount'}>
              <span>
                {soundcasts.length} {soundcasts.length > 1 ? 'Soundcasts' : 'Soundcast'}
              </span>
            </div>
            <div className={'lastUpdated'}>
              <span>Last Updated: {moment(category.createdAt).format('MMM DD YYYY')}</span>
            </div>
            <div className={'editCategoryBtn'}>
              <div className="dropdown pull-right">
                <div
                  id="multi-action-dropdown"
                  className="btn dropdown-toggle"
                  data-toggle="dropdown">
                  <i className="fas fa-ellipsis-v" />
                </div>
                <ul className="dropdown-menu alt-font">
                  {category.featured ? (
                    <li>
                      <a
                        datatoggle="tooltip"
                        dataplacement="top"
                        title="set as featured"
                        onClick={() => onClearFeatured(category.id)}>
                        Remove as Featured
                      </a>
                    </li>
                  ) : (
                    <li>
                      <a
                        datatoggle="tooltip"
                        dataplacement="top"
                        title="set as featured"
                        onClick={() => onSetAsFeatured(category.id)}>
                        Set as Featured
                      </a>
                    </li>
                  )}
                  <li>
                    <a
                      datatoggle="tooltip"
                      dataplacement="top"
                      title="edit soundcasts"
                      onClick={() => onEdit(category.id)}>
                      Edit Soundcasts
                    </a>
                  </li>
                  <li>
                    <a
                      datatoggle="tooltip"
                      dataplacement="top"
                      title="delete category"
                      onClick={() => onDelete(category.id)}>
                      Delete Category
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </CategoryRow>
        </div>
      )}
    </Draggable>
  );
}

const ItemIcon = styled.i`
  cursor: pointer;
`;
